// ヘッダー背景の切り替え
function onScroll() {
  const header =
    document.querySelector('#js-header') ||
    document.querySelector('#js-header-top');
  const scroll = window.pageYOffset;

  if (header) {
    if (scroll > 200) {
      header.classList.add('is-scroll');
    } else {
      header.classList.remove('is-scroll');
    }
  }
}

window.addEventListener('scroll', onScroll);
